module.exports = __webpack_public_path__ + "static/media/datazip.f73e4252.svg";